export interface IBanklog {
  id?: number;
  login?: string | null;
  request?: string | null;
  response?: string | null;
}

export const defaultValue: Readonly<IBanklog> = {};
